import * as constants from './constants'

export const addCreditCard = (name, cardNumber, expiryMonth, expiryYear, zipCode) => ({
    type: constants.ADD_CREDIT_CARD,
    name,
    cardNumber,
    expiryMonth,
    expiryYear,
    zipCode,
})
